import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';

const Changelog = () => {
  const versions = [
    {
      version: 'v1.2.0',
      date: '2024-01-15',
      type: 'feature',
      changes: [
        '✨ 新增:支持场景模板快速生成行程',
        '✨ 新增:打卡相册网格/时间线双视图模式',
        '🎨 优化:全新的苹果风格UI设计',
        '🐛 修复:部分用户无法保存行程的问题',],
    },
    {
      version: 'v1.1.0',
      date: '2024-01-01',
      type: 'feature',
      changes: [
        '✨ 新增:旅行日记支持富文本编辑',
        '✨ 新增:行程导出为图片功能',
        '⚡ 性能:优化AI生成速度,提升30%',
        '🐛 修复:Safari浏览器兼容性问题',
      ],
    },
    {
      version: 'v1.0.5',
      date: '2023-12-20',
      type: 'fix',
      changes: [
        '🐛 修复:登录状态偶尔丢失的问题',
        '🐛 修复:部分Android设备无法上传照片',
        '🎨 优化:移动端布局适配',
      ],
    },
    {
      version: 'v1.0.0',
      date: '2023-12-01',
      type: 'major',
      changes: [
        '🎉 正式版发布!',
        '✨ AI智能行程规划',
        '✨ 旅行日记功能',
        '✨ 打卡相册功能',
        '✨ 用户个人中心',
      ],
    },
  ];

  const getTypeBadge = (type) => {
    const badges = {
      major: { label: '重大更新', className: 'bg-[#007AFF] text-white' },
      feature: { label: '新功能', className: 'bg-[#34C759] text-white' },
      fix: { label: '问题修复', className: 'bg-[#FF9500] text-white' },
    };
    return badges[type] || badges.feature;
  };

  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#F5F5F7] mb-4">
            <Clock className="w-8 h-8 text-[#007AFF]" />
          </div>
          <h1 className="text-4xl font-bold text-[#1D1D1F] mb-4 tracking-tight">更新日志</h1>
          <p className="text-lg text-[#86868B] max-w-2xl mx-auto">
            记录产品的每一次进步与优化
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-[#E8E8ED]" />
          <div className="space-y-8">
            {versions.map((ver, idx) => {
              const badge = getTypeBadge(ver.type);
              return (
                <div key={idx} className="relative pl-16">
                  <div className="absolute left-3.5 top-2 w-5 h-5 rounded-full bg-[#007AFF] border-4 border-white shadow-sm" />
                  <Card className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#FFFFFF] hover:shadow-[0_8px_30px_rgba(0,0,0,0.06)] transition-all">
                    <CardContent className="p-6">
                      <div className="flex items-center gap-3 mb-4">
                        <h2 className="text-xl font-bold text-[#1D1D1F]">{ver.version}</h2>
                        <Badge className={`${badge.className} rounded-full`}>{badge.label}</Badge><span className="text-sm text-[#86868B] ml-auto">{ver.date}</span>
                      </div>
                      <ul className="space-y-2">
                        {ver.changes.map((change, cIdx) => (
                          <li key={cIdx} className="text-[#86868B] leading-relaxed flex items-start gap-2">
                            <span className="shrink-0">{change}</span>
                          </li>
                        ))}
                      </ul>
                    </CardContent>
                  </Card>
                </div>
              );
            })}
          </div>
        </div>

        <Card className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#F5F5F7] mt-12">
          <CardContent className="p-8 text-center">
            <h3 className="text-lg font-bold text-[#1D1D1F] mb-2">即将上线</h3>
            <p className="text-[#86868B]">
              🚀 行程协同编辑 ·🗺️ 地图导航集成 · 📱 移动端App · 🎁 积分商城
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Changelog;
